import { Box, Typography, Container } from "@mui/material";
import { ReactComponent as Cloud } from "../../../assets/ExplorePageCloud.svg";
import { makeStyles } from "@mui/styles";
import { useContext } from "react";
import { CourseStructureContext } from "../../../context/CourseStructureContext";
import { CourseStructureCtx } from "../../../interfaces";

interface ExploreHeaderProps {
  title: string;
}

const useStyle = makeStyles((theme) => ({
  root: {
    position: "relative",
    paddingLeft: 30,
    paddingRight: 30,
    maxWidth: "1280px",
  },
}));

export const ExploreHomeHeader = (props: ExploreHeaderProps) => {
  let { title } = props;
  const courseStructureCtx = useContext(CourseStructureContext) as CourseStructureCtx;
  const courseTree = courseStructureCtx.courseTreeStructure;
  const courseMetadata = courseTree?.getCurrentCourseMetadata();
  const classes = useStyle();

  return (
    <Box
      sx={{
        height: "166px",
        width: "100%",
        backgroundColor: `${courseMetadata?.color || "#000000"}`,
        display: "flex",
        position: "relative",
        padding: "0px 30px",
      }}
      role="main"
      id="main"
      component="main">
      <Container disableGutters maxWidth={false} className={classes.root}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
          }}>
          <Box
            sx={{
              flexShrink: 1,
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              // maxWidth: "calc(100% - 740px)",
              maxWidth: "582px",
              marginTop: "63px",
            }}>
            <Typography sx={{ color: "#FAFAFA" }} variant="h2" component="span">
              {title}
            </Typography>
          </Box>
          <Cloud
            fill={`${courseMetadata?.explore_page_cloud_color || "#000000"}`}
            style={{
              position: "absolute",
              height: "225px",
              width: "365px",
              top: "-18%",
              right: "-2%",
            }}
          />
          <img
            src={`${courseMetadata?.icon}`}
            alt={"icon"}
            loading="lazy"
            style={{
              width: "80px",
              height: "80px",
              position: "absolute",
              top: "30%",
              right: "13%",
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};
